// extracted by mini-css-extract-plugin
export var number = "styles-module--number--c2451";
export var red = "styles-module--red--22e2b";
export var teal = "styles-module--teal--21988";